import { IListingInBuyPage } from '@/src/components/UI/HouseDetail/HouseDetailContainerProps';
import { isEmptyArray } from '@/utils/formatChecker';

const TOP_ORDER_PLAN_TYPES = ['studio'];

export function sortListingPlanType(a: string, b: string): number {
  const lowerA = a.toLocaleLowerCase();
  const lowerB = b.toLocaleLowerCase();
  const isATopOrder = TOP_ORDER_PLAN_TYPES.includes(lowerA);
  const isBTopOrder = TOP_ORDER_PLAN_TYPES.includes(lowerB);
  if (isATopOrder && !isBTopOrder) return -1;
  if (!isATopOrder && isBTopOrder) return 1;
  if (isATopOrder && isBTopOrder) {
    const aIndexInTopOrder = TOP_ORDER_PLAN_TYPES.indexOf(lowerA);
    const bIndexInTopOrder = TOP_ORDER_PLAN_TYPES.indexOf(lowerB);
    return aIndexInTopOrder - bIndexInTopOrder;
  } else {
    return a.localeCompare(b);
  }
}

export const getLayout = (
  { room, common_space, bath, country }: Pick<IListingInBuyPage, 'room' | 'common_space' | 'bath' | 'country'>,
  floorPlanType?: string | null
): string => {
  if (floorPlanType?.toLocaleLowerCase() === 'studio') return 'Studio';

  const result: Array<string> = [];

  if (Number(room)) result.push(`${room} 房`);
  if (Number(common_space) && country === 'TW') result.push(`${common_space}  廳`);
  if (Number(bath)) result.push(`${bath} 衛`);

  if (isEmptyArray(result)) return '-';
  return result.join(' ');
};
